import {Component, OnInit} from '@angular/core';
import {RestAPIService} from '../shared/shared-service/restAPI.service';
import {Router} from '@angular/router';
import {SharedDataService} from '../shared/shared-data/shared-data.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

   totalUsers: number;
   totalApplications: number;
   succesfulAttempts: number;
   failedAttempts: number;
   applications: string;
   applicationLogs: string;
   applicationStats: string;
   applicationLogsInfoText: string = '';

  constructor(private restAPIService: RestAPIService, private sharedDataService: SharedDataService) {
  }

  ngOnInit() {
    this.getDashoardDetails();
    this.applications = '/layout/applications';
    this.applicationLogs = '/layout/loginlog/successful';
    this.applicationStats = '/layout/loginlog/failed';
  }

  getDashoardDetails(): any {
    this.restAPIService.getDashboardDetails().then(details => {
      this.applicationLogsInfoText = '(For last '+details.lookbackDays+' days)';
      this.totalApplications = details.totalApplicationCount;
      this.succesfulAttempts = details.totalSuccessfulAttempts;
      this.failedAttempts = details.totalFailedAttempts;
      this.totalUsers = details.totalUsersCount;
    }).catch(error => {
      this.sharedDataService.showError(error.message);
    });
  }
}
